















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { UserReferring } from "@scrile/api-provider/dist/api/UserReferringProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import AvatarDescription from "@/components/AvatarDescription/AvatarDescription.vue";
import InfiniteScroll from "@/components/InfiniteScroll";

@Component({ name: "ReferralsList", components: { AvatarDescription, InfiniteScroll } })
export default class ReferralsList extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly enableScroll!: boolean;

  @Prop({ type: Array, required: true })
  public readonly userReferrings!: UserReferring[];

  public getProfileUrl = getProfileUrl;
}
